// FactoryLicenseRegistration.jsx
import React from "react";

export default function FactoryLicenseRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Factory License
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Factory License Registration Support
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists in Factory License registration under
            the Factories Act, helping industrial units align with safety,
            health, and labour law requirements before commencing operations.[web:208][web:210]
          </p>
          <p className="text-gray-700">
            Support typically covers preparation of plans, detailing processes
            and machinery, and presenting occupier and manager information in
            the format expected by state factory inspectorates.[web:209][web:212]
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/585418/pexels-photo-585418.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Factory floor with machinery representing industrial licensing"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Factory License
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps factories compile the core documents
              usually requested by state authorities for registration and grant
              of license.[web:208][web:210][web:216]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Factory layout and site plan / approved building plan showing
                  production areas, utilities, exits, and safety arrangements.[web:208][web:210]
                </li>
                <li>
                  Details of the occupier and manager, including name, address,
                  identification details, and nature of manufacturing process
                  overseen.[web:209][web:212]
                </li>
                <li>
                  Address proof of premises such as ownership documents or lease
                  agreement, along with recent municipal or utility records.[web:208][web:210]
                </li>
                <li>
                  Machinery details and particulars of manufacturing processes,
                  including horsepower, types of equipment, and any hazardous
                  processes involved.[web:210][web:215]
                </li>
                <li>
                  Basic business documents (PAN, incorporation/registration
                  papers, list of directors/partners) and applicable NOCs such
                  as pollution or fire clearances, depending on state rules.[web:210][web:214][web:217]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm’s support is oriented around industrial operations,
              focusing on both documentation quality and practical interaction
              with regulatory authorities.[web:208][web:209]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Strong Industrial Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on how factory license requirements tie into worker
                  safety, health, welfare, and environmental obligations under
                  the Factories Act and model rules.[web:209][web:213][web:215]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance in preparing application forms, plans, and annexures
                  correctly to reduce the likelihood of queries and repeated
                  submissions.[web:208][web:216][web:217]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Regulatory Coordination
                </h3>
                <p className="text-gray-700 text-sm">
                  Support across plan approval, inspection, license grant, and
                  renewals, providing a consistent interface with state labour
                  and factory inspectorates.[web:211][web:212][web:214]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
